import { Stack, Typography, styled } from "@mui/material";
import { getScoreColor } from "~src/utils/scores";

type SemiDonutProps = {
  percentage: number;
  color: string;
};

const SemiDonut = styled("div")<SemiDonutProps>(({ percentage, color }) => ({
  "--percentage": percentage || 0,
  "--fill": color,
  width: "80px",
  height: "50px",
  position: "relative",
  fontSize: "22px",
  fontWeight: 400,
  overflow: "hidden",
  color: "var(--fill)",
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
  boxSizing: "border-box",

  "&:after": {
    content: '""',
    width: "80px",
    height: "80px",
    border: "10.24px solid",
    borderColor:
      "rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.15) var(--fill) var(--fill)",
    position: "absolute",
    borderRadius: "50%",
    left: "0",
    top: "0",
    boxSizing: "border-box",
    transform: `rotate(calc(1deg * (-45 + var(--percentage) * 1.8)))`,
    animation: "fillAnimation 0.5s ease-in",
  },
}));

const FillAnimation = styled("div")`
  @keyframes fillAnimation {
    0% {
      transform: rotate(-45deg);
    }
  }
`;

export const BrandCardChart = ({
  label,
  number,
}: {
  label: string;
  number: number;
}) => {
  return (
    <SemiDonut percentage={number} color={getScoreColor(number)}>
      <FillAnimation />
      <Stack
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "grey.900",
            fontSize: "10px",
            position: "relative",
            top: "14px"
          }}>
          {label}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: "grey.900",
            position: "relative",
            top: "8px"
          }}>
          {number}
        </Typography>
      </Stack>
    </SemiDonut>
  );
};
